module.exports = __webpack_public_path__ + "img/copaAmerica214.3eda14fa.jpg";